function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo } from "react";
import { UI, DayFlag, SelectionState } from "./UI.js";
import { getClassNamesForModifiers } from "./helpers/getClassNamesForModifiers.js";
import { getComponents } from "./helpers/getComponents.js";
import { getDataAttributes } from "./helpers/getDataAttributes.js";
import { getDateLib } from "./helpers/getDateLib.js";
import { getDefaultClassNames } from "./helpers/getDefaultClassNames.js";
import { getFormatters } from "./helpers/getFormatters.js";
import { getMonthOptions } from "./helpers/getMonthOptions.js";
import { getStyleForModifiers } from "./helpers/getStyleForModifiers.js";
import { getWeekdays } from "./helpers/getWeekdays.js";
import { getYearOptions } from "./helpers/getYearOptions.js";
import * as defaultLabels from "./labels/index.js";
import { enUS } from "./lib/locales.js";
import { useCalendar } from "./useCalendar.js";
import { dayPickerContext } from "./useDayPicker.js";
import { useFocus } from "./useFocus.js";
import { useGetModifiers } from "./useGetModifiers.js";
import { useSelection } from "./useSelection.js";
import { rangeIncludesDate } from "./utils/rangeIncludesDate.js";
import { isDateRange } from "./utils/typeguards.js";
/**
 * Render the date picker calendar.
 *
 * @group DayPicker
 * @see https://daypicker.dev
 */
export function DayPicker(props) {
  var _useSelection;
  var _useMemo = useMemo(function () {
      return {
        dateLib: getDateLib(props.dateLib),
        components: getComponents(props.components),
        formatters: getFormatters(props.formatters),
        labels: _objectSpread(_objectSpread({}, defaultLabels), props.labels),
        locale: _objectSpread(_objectSpread({}, enUS), props.locale),
        classNames: _objectSpread(_objectSpread({}, getDefaultClassNames()), props.classNames)
      };
    }, [props.classNames, props.components, props.dateLib, props.formatters, props.labels, props.locale]),
    components = _useMemo.components,
    formatters = _useMemo.formatters,
    labels = _useMemo.labels,
    dateLib = _useMemo.dateLib,
    locale = _useMemo.locale,
    classNames = _useMemo.classNames;
  var captionLayout = props.captionLayout,
    firstWeekContainsDate = props.firstWeekContainsDate,
    mode = props.mode,
    onDayBlur = props.onDayBlur,
    onDayClick = props.onDayClick,
    onDayFocus = props.onDayFocus,
    onDayKeyDown = props.onDayKeyDown,
    onDayMouseEnter = props.onDayMouseEnter,
    onDayMouseLeave = props.onDayMouseLeave,
    onNextClick = props.onNextClick,
    onPrevClick = props.onPrevClick,
    showWeekNumber = props.showWeekNumber,
    styles = props.styles,
    useAdditionalDayOfYearTokens = props.useAdditionalDayOfYearTokens,
    useAdditionalWeekYearTokens = props.useAdditionalWeekYearTokens,
    weekStartsOn = props.weekStartsOn;
  var formatOptions = {
    locale: locale,
    weekStartsOn: weekStartsOn,
    firstWeekContainsDate: firstWeekContainsDate,
    useAdditionalWeekYearTokens: useAdditionalWeekYearTokens,
    useAdditionalDayOfYearTokens: useAdditionalDayOfYearTokens
  };
  var labelOptions = formatOptions;
  var formatCaption = formatters.formatCaption,
    formatDay = formatters.formatDay,
    formatMonthDropdown = formatters.formatMonthDropdown,
    formatWeekNumber = formatters.formatWeekNumber,
    formatWeekNumberHeader = formatters.formatWeekNumberHeader,
    formatWeekdayName = formatters.formatWeekdayName,
    formatYearDropdown = formatters.formatYearDropdown;
  var calendar = useCalendar(props, dateLib);
  var days = calendar.days,
    months = calendar.months,
    navStart = calendar.navStart,
    navEnd = calendar.navEnd,
    previousMonth = calendar.previousMonth,
    nextMonth = calendar.nextMonth,
    goToMonth = calendar.goToMonth;
  var getModifiers = useGetModifiers(days, props, dateLib);
  var _ref = (_useSelection = useSelection(props, dateLib)) !== null && _useSelection !== void 0 ? _useSelection : {},
    isSelected = _ref.isSelected,
    select = _ref.select,
    selectedValue = _ref.selected;
  var _useFocus = useFocus(props, calendar, getModifiers, isSelected !== null && isSelected !== void 0 ? isSelected : function () {
      return false;
    }, dateLib),
    blur = _useFocus.blur,
    focused = _useFocus.focused,
    isFocusTarget = _useFocus.isFocusTarget,
    moveFocus = _useFocus.moveFocus,
    setFocused = _useFocus.setFocused;
  var labelDayButton = labels.labelDayButton,
    labelGridcell = labels.labelGridcell,
    labelGrid = labels.labelGrid,
    labelMonthDropdown = labels.labelMonthDropdown,
    labelNav = labels.labelNav,
    labelNext = labels.labelNext,
    labelPrevious = labels.labelPrevious,
    labelWeekday = labels.labelWeekday,
    labelWeekNumber = labels.labelWeekNumber,
    labelWeekNumberHeader = labels.labelWeekNumberHeader,
    labelYearDropdown = labels.labelYearDropdown;
  var weekdays = useMemo(function () {
    return getWeekdays(locale, props.weekStartsOn, props.ISOWeek, dateLib);
  }, [dateLib, locale, props.ISOWeek, props.weekStartsOn]);
  var isInteractive = mode !== undefined || onDayClick !== undefined;
  var handlePreviousClick = useCallback(function () {
    if (!previousMonth) return;
    goToMonth(previousMonth);
    onPrevClick === null || onPrevClick === void 0 ? void 0 : onPrevClick(previousMonth);
  }, [previousMonth, goToMonth, onPrevClick]);
  var handleNextClick = useCallback(function () {
    if (!nextMonth) return;
    goToMonth(nextMonth);
    onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(nextMonth);
  }, [goToMonth, nextMonth, onNextClick]);
  var handleDayClick = useCallback(function (day, m) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();
      setFocused(day);
      select === null || select === void 0 ? void 0 : select(day.date, m, e);
      onDayClick === null || onDayClick === void 0 ? void 0 : onDayClick(day.date, m, e);
    };
  }, [select, onDayClick, setFocused]);
  var handleDayFocus = useCallback(function (day, m) {
    return function (e) {
      setFocused(day);
      onDayFocus === null || onDayFocus === void 0 ? void 0 : onDayFocus(day.date, m, e);
    };
  }, [onDayFocus, setFocused]);
  var handleDayBlur = useCallback(function (day, m) {
    return function (e) {
      blur();
      onDayBlur === null || onDayBlur === void 0 ? void 0 : onDayBlur(day.date, m, e);
    };
  }, [blur, onDayBlur]);
  var handleDayKeyDown = useCallback(function (day, modifiers) {
    return function (e) {
      var keyMap = {
        ArrowLeft: ["day", props.dir === "rtl" ? "after" : "before"],
        ArrowRight: ["day", props.dir === "rtl" ? "before" : "after"],
        ArrowDown: ["week", "after"],
        ArrowUp: ["week", "before"],
        PageUp: [e.shiftKey ? "year" : "month", "before"],
        PageDown: [e.shiftKey ? "year" : "month", "after"],
        Home: ["startOfWeek", "before"],
        End: ["endOfWeek", "after"]
      };
      if (keyMap[e.key]) {
        e.preventDefault();
        e.stopPropagation();
        var _keyMap$e$key = _slicedToArray(keyMap[e.key], 2),
          moveBy = _keyMap$e$key[0],
          moveDir = _keyMap$e$key[1];
        moveFocus(moveBy, moveDir);
      }
      onDayKeyDown === null || onDayKeyDown === void 0 ? void 0 : onDayKeyDown(day.date, modifiers, e);
    };
  }, [moveFocus, onDayKeyDown, props.dir]);
  var handleDayMouseEnter = useCallback(function (day, modifiers) {
    return function (e) {
      onDayMouseEnter === null || onDayMouseEnter === void 0 ? void 0 : onDayMouseEnter(day.date, modifiers, e);
    };
  }, [onDayMouseEnter]);
  var handleDayMouseLeave = useCallback(function (day, modifiers) {
    return function (e) {
      onDayMouseLeave === null || onDayMouseLeave === void 0 ? void 0 : onDayMouseLeave(day.date, modifiers, e);
    };
  }, [onDayMouseLeave]);
  var _useMemo2 = useMemo(function () {
      return {
        className: [classNames[UI.Root], props.className].filter(Boolean).join(" "),
        style: _objectSpread(_objectSpread({}, styles === null || styles === void 0 ? void 0 : styles[UI.Root]), props.style)
      };
    }, [classNames, props.className, props.style, styles]),
    className = _useMemo2.className,
    style = _useMemo2.style;
  var dataAttributes = getDataAttributes(props);
  var contextValue = {
    selected: selectedValue,
    select: select,
    isSelected: isSelected,
    months: months,
    nextMonth: nextMonth,
    previousMonth: previousMonth,
    goToMonth: goToMonth,
    getModifiers: getModifiers
  };
  return /*#__PURE__*/React.createElement(dayPickerContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(components.Root, _objectSpread({
    className: className,
    style: style,
    dir: props.dir,
    id: props.id,
    lang: props.lang,
    nonce: props.nonce,
    title: props.title
  }, dataAttributes), /*#__PURE__*/React.createElement(components.Months, {
    className: classNames[UI.Months],
    style: styles === null || styles === void 0 ? void 0 : styles[UI.Months]
  }, !props.hideNavigation && ( /*#__PURE__*/React.createElement(components.Nav, {
    role: "navigation",
    className: classNames[UI.Nav],
    style: styles === null || styles === void 0 ? void 0 : styles[UI.Nav],
    "aria-label": labelNav()
  }, /*#__PURE__*/React.createElement(components.Button, {
    type: "button",
    className: classNames[UI.ButtonPrevious],
    tabIndex: previousMonth ? undefined : -1,
    disabled: previousMonth ? undefined : true,
    "aria-label": labelPrevious(previousMonth, labelOptions),
    onClick: handlePreviousClick
  }, /*#__PURE__*/React.createElement(components.Chevron, {
    disabled: previousMonth ? undefined : true,
    className: classNames[UI.Chevron],
    orientation: "left"
  })), /*#__PURE__*/React.createElement(components.Button, {
    type: "button",
    className: classNames[UI.ButtonNext],
    tabIndex: nextMonth ? undefined : -1,
    disabled: nextMonth ? undefined : true,
    "aria-label": labelNext(nextMonth, labelOptions),
    onClick: handleNextClick
  }, /*#__PURE__*/React.createElement(components.Chevron, {
    disabled: previousMonth ? undefined : true,
    orientation: "right",
    className: classNames[UI.Chevron]
  })))), months.map(function (calendarMonth, displayIndex) {
    var handleMonthChange = function handleMonthChange(e) {
      var selectedMonth = Number(e.target.value);
      var month = dateLib.setMonth(dateLib.startOfMonth(calendarMonth.date), selectedMonth);
      goToMonth(month);
    };
    var handleYearChange = function handleYearChange(e) {
      var month = dateLib.setYear(dateLib.startOfMonth(calendarMonth.date), Number(e.target.value));
      goToMonth(month);
    };
    var dropdownMonths = getMonthOptions(calendarMonth.date, navStart, navEnd, formatters, locale, dateLib);
    var dropdownYears = getYearOptions(months[0].date, navStart, navEnd, formatters, dateLib);
    return /*#__PURE__*/React.createElement(components.Month, {
      className: classNames[UI.Month],
      style: styles === null || styles === void 0 ? void 0 : styles[UI.Month],
      key: displayIndex,
      displayIndex: displayIndex,
      calendarMonth: calendarMonth
    }, /*#__PURE__*/React.createElement(components.MonthCaption, {
      className: classNames[UI.MonthCaption],
      style: styles === null || styles === void 0 ? void 0 : styles[UI.MonthCaption],
      calendarMonth: calendarMonth,
      displayIndex: displayIndex
    }, captionLayout !== null && captionLayout !== void 0 && captionLayout.startsWith("dropdown") ? ( /*#__PURE__*/React.createElement(components.DropdownNav, {
      className: classNames[UI.Dropdowns],
      style: styles === null || styles === void 0 ? void 0 : styles[UI.Dropdowns]
    }, captionLayout === "dropdown" || captionLayout === "dropdown-months" ? ( /*#__PURE__*/React.createElement(components.Dropdown, {
      "aria-label": labelMonthDropdown(),
      classNames: classNames,
      components: components,
      disabled: Boolean(props.disableNavigation),
      onChange: handleMonthChange,
      options: dropdownMonths,
      style: styles === null || styles === void 0 ? void 0 : styles[UI.Dropdown],
      value: calendarMonth.date.getMonth()
    })) : ( /*#__PURE__*/React.createElement("span", {
      role: "status",
      "aria-live": "polite"
    }, formatMonthDropdown(calendarMonth.date.getMonth()))), captionLayout === "dropdown" || captionLayout === "dropdown-years" ? ( /*#__PURE__*/React.createElement(components.Dropdown, {
      "aria-label": labelYearDropdown(labelOptions),
      classNames: classNames,
      components: components,
      disabled: Boolean(props.disableNavigation),
      onChange: handleYearChange,
      options: dropdownYears,
      style: styles === null || styles === void 0 ? void 0 : styles[UI.Dropdown],
      value: calendarMonth.date.getFullYear()
    })) : ( /*#__PURE__*/React.createElement("span", {
      role: "status",
      "aria-live": "polite"
    }, formatYearDropdown(calendarMonth.date.getFullYear()))))) : ( /*#__PURE__*/React.createElement(components.CaptionLabel, {
      className: classNames[UI.CaptionLabel],
      role: "status",
      "aria-live": "polite"
    }, formatCaption(calendarMonth.date, formatOptions, dateLib)))), /*#__PURE__*/React.createElement(components.MonthGrid, {
      role: "grid",
      "aria-multiselectable": mode === "multiple" || mode === "range",
      "aria-label": labelGrid(calendarMonth.date, labelOptions, dateLib) || undefined,
      className: classNames[UI.MonthGrid],
      style: styles === null || styles === void 0 ? void 0 : styles[UI.MonthGrid]
    }, !props.hideWeekdays && ( /*#__PURE__*/React.createElement(components.Weekdays, {
      className: classNames[UI.Weekdays],
      role: "row",
      style: styles === null || styles === void 0 ? void 0 : styles[UI.Weekdays]
    }, showWeekNumber && ( /*#__PURE__*/React.createElement(components.WeekNumberHeader, {
      "aria-label": labelWeekNumberHeader(labelOptions),
      className: classNames[UI.WeekNumberHeader],
      role: "columnheader",
      style: styles === null || styles === void 0 ? void 0 : styles[UI.WeekNumberHeader]
    }, formatWeekNumberHeader())), weekdays.map(function (weekday, i) {
      return /*#__PURE__*/React.createElement(components.Weekday, {
        "aria-label": labelWeekday(weekday, labelOptions, dateLib),
        className: classNames[UI.Weekday],
        key: i,
        role: "columnheader",
        style: styles === null || styles === void 0 ? void 0 : styles[UI.Weekday]
      }, formatWeekdayName(weekday, formatOptions, dateLib));
    }))), /*#__PURE__*/React.createElement(components.Weeks, {
      className: classNames[UI.Weeks],
      role: "rowgroup",
      style: styles === null || styles === void 0 ? void 0 : styles[UI.Weeks]
    }, calendarMonth.weeks.map(function (week, weekIndex) {
      return /*#__PURE__*/React.createElement(components.Week, {
        className: classNames[UI.Week],
        key: week.weekNumber,
        role: "row",
        style: styles === null || styles === void 0 ? void 0 : styles[UI.Week],
        week: week
      }, showWeekNumber && ( /*#__PURE__*/React.createElement(components.WeekNumber, {
        week: week,
        role: "rowheader",
        style: styles === null || styles === void 0 ? void 0 : styles[UI.WeekNumber],
        "aria-label": labelWeekNumber(week.weekNumber, {
          locale: locale
        }),
        className: classNames[UI.WeekNumber]
      }, formatWeekNumber(week.weekNumber))), week.days.map(function (day) {
        var date = day.date;
        var modifiers = getModifiers(day);
        modifiers[DayFlag.focused] = !modifiers.hidden && Boolean(focused === null || focused === void 0 ? void 0 : focused.isEqualTo(day));
        modifiers[SelectionState.selected] = !modifiers.disabled && ((isSelected === null || isSelected === void 0 ? void 0 : isSelected(date)) || modifiers.selected);
        if (isDateRange(selectedValue)) {
          // add range modifiers
          var from = selectedValue.from,
            to = selectedValue.to;
          modifiers[SelectionState.range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
          modifiers[SelectionState.range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
          modifiers[SelectionState.range_middle] = rangeIncludesDate(selectedValue, date, true, dateLib);
        }
        var style = getStyleForModifiers(modifiers, styles, props.modifiersStyles);
        var className = getClassNamesForModifiers(modifiers, classNames, props.modifiersClassNames);
        var ariaLabel = !isInteractive ? labelGridcell(date, modifiers, labelOptions, dateLib) : undefined;
        return /*#__PURE__*/React.createElement(components.Day, {
          key: "".concat(dateLib.format(date, "yyyy-MM-dd"), "_").concat(dateLib.format(day.displayMonth, "yyyy-MM")),
          day: day,
          modifiers: modifiers,
          role: "gridcell",
          className: className.join(" "),
          style: style,
          "aria-hidden": modifiers.hidden || undefined,
          "aria-selected": modifiers.selected || undefined,
          "aria-label": ariaLabel,
          "data-day": dateLib.format(date, "yyyy-MM-dd"),
          "data-month": day.outside ? dateLib.format(date, "yyyy-MM") : undefined,
          "data-selected": modifiers.selected || undefined,
          "data-disabled": modifiers.disabled || undefined,
          "data-hidden": modifiers.hidden || undefined,
          "data-outside": day.outside || undefined,
          "data-focused": modifiers.focused || undefined,
          "data-today": modifiers.today || undefined
        }, isInteractive ? ( /*#__PURE__*/React.createElement(components.DayButton, {
          className: classNames[UI.DayButton],
          style: styles === null || styles === void 0 ? void 0 : styles[UI.DayButton],
          day: day,
          modifiers: modifiers,
          disabled: modifiers.disabled || undefined,
          tabIndex: isFocusTarget(day) ? 0 : -1,
          "aria-label": labelDayButton(date, modifiers, labelOptions, dateLib),
          onClick: handleDayClick(day, modifiers),
          onBlur: handleDayBlur(day, modifiers),
          onFocus: handleDayFocus(day, modifiers),
          onKeyDown: handleDayKeyDown(day, modifiers),
          onMouseEnter: handleDayMouseEnter(day, modifiers),
          onMouseLeave: handleDayMouseLeave(day, modifiers)
        }, formatDay(date, formatOptions, dateLib))) : formatDay(day.date, formatOptions, dateLib));
      }));
    }))));
  })), props.footer && ( /*#__PURE__*/React.createElement(components.Footer, {
    className: classNames[UI.Footer],
    style: styles === null || styles === void 0 ? void 0 : styles[UI.Footer],
    role: "status",
    "aria-live": "polite"
  }, props.footer))));
}